export const langEn = {
  'common.expected_finish': 'Expected Finish',
  'common.minutes': 'min',
  'common.seconds': 'sec',
  'common.now': 'Now',
  'common.next': 'Next',
  'common.scheduled_start': 'Scheduled start',
  'common.scheduled_end': 'Scheduled end',
  'common.expected_start': 'Expected start',
  'common.expected_end': 'Expected end',
  'common.timer_message': 'Timer message',
  'common.secondary_message': 'Secondary message',
  'common.stage_timer': 'Stage Timer',
  'common.started_at': 'Started At',
  'common.time_now': 'Time now',
  'common.no_data': 'No data',
  'countdown.ended': 'Event ended at',
  'countdown.running': 'Event running',
  'countdown.loaded': 'Event loaded',
  'countdown.select_event': 'Select an event to follow',
  'countdown.to_start': 'Time to start',
  'countdown.waiting': 'Waiting for event start',
  'countdown.overtime': 'in overtime',
  'countdown.all_have_finished': 'All selected events have finished',
  'timeline.live': 'live',
  'timeline.done': 'done',
  'timeline.due': 'due',
  'timeline.followedby': 'Followed by',
  'project.title': 'Title',
  'project.description': 'Description',
  'project.info': 'Project Info',
  'project.url': 'Project URL',
};

export type TranslationObject = Record<keyof typeof langEn, string>;
